import React from 'react';

// Helpers
import { checkInput, extractTime } from '../../helpers/helpers.js';

class TimeSelect extends React.Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    this.state = {
      time: extractTime(this.props.defaultValue)
    }

    this.props.parent.setState({
      [this.props.stateName]: extractTime(this.props.defaultValue)
    })
  }

  handleChange() {
    let hour = this.hour.value;
    const minute = this.minute.value;
    const ampm = this.ampm.value;

    if(ampm === 'pm' && hour < 12) {
      hour = parseInt(hour, 10) + 12;
    } else if(ampm === 'am' && hour >= 12) {
      hour = parseInt(hour, 10) - 12;
    }

    if(hour < 10 && hour.toString().length === 1) {
      hour = '0' + hour;
    }

    const time = `${hour}:${minute}`;

    this.fallback.value = time;

    // Trigger an event on the hidden input
    let event = null;

    try {
      event = new Event('fallback', {bubbles: true});
    } catch(e) {
      event = document.createEvent('Event');
      event.initEvent('fallback', true, true)
    }

    const _this = this;
    const { date, handleInput, name } = this.props;

    this.fallback.addEventListener('fallback', function(e){
      handleInput(name, e, true, date, e.target.value);
    });

    this.fallback.dispatchEvent(event);
  }

  render() {
    const { importedLmsExam } = this.props.store.ExamStore;
    const defaultTime = extractTime(this.props.defaultValue);
    let defaultHr = defaultTime.split(':')[0];
    const defaultMin = defaultTime.split(':')[1];
    let defaultAmpm = 'am';

    if(defaultHr > 11) {
      defaultAmpm = 'pm';
    }

    if(defaultHr > 12) {
      defaultHr = parseInt(defaultHr, 10) - 12;
    }

    if(defaultHr < 10 && defaultHr.toString().length === 1) {
      defaultHr = '0' + defaultHr;
    }

    if(!this.props.defaultValue && Object.keys(importedLmsExam).length > 0) {
      // This is hacky, but for some reason
      // when importing an exam, the defaultValue
      // comes through as null at first which causes
      // the input to render with no default date
      // so we’re going to check if the default value is
      // null and if we are importing an exam. If true,
      // we’ll return nothing so that the default value
      // on the time input works as expected.
      return null;
    }

    if(checkInput('time')) {
      // If time inputs are supported by the browser
      return (
        <input
          type="time"
          id={this.props.id}
          defaultValue={extractTime(this.props.defaultValue)}
          ref={this.props.reference}
          onChange={this.props.onChange}
          placeholder="hh:mm"
          disabled={this.props.disabled ? true : false}
        />
      )
    } else {
      // Otherwise, fallback to three selects
      return (
        <div className="inline-wrap">
          <input
            type="text"
            id={this.props.id}
            className="inp-hidden"
            defaultValue={this.state.time}
            ref={(input) => {this.fallback = input}}
            placeholder="hh:mm"
          />

          <label className="select">
            <select
              ref={(input) => {this.hour = input}}
              onChange={this.handleChange}
              defaultValue={defaultHr}
              disabled={this.props.disabled ? true : false}
            >
              <option value="12">12</option>
              <option value="01">1</option>
              <option value="02">2</option>
              <option value="03">3</option>
              <option value="04">4</option>
              <option value="05">5</option>
              <option value="06">6</option>
              <option value="07">7</option>
              <option value="08">8</option>
              <option value="09">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
            </select>
          </label>

          <span className="preposition">:</span>

          <label className="select">
            <select
              ref={(input) => {this.minute = input}}
              onChange={this.handleChange}
              defaultValue={defaultMin}
              disabled={this.props.disabled ? true : false}
            >
              <option value="00">00</option>
              <option value="01">01</option>
              <option value="02">02</option>
              <option value="03">03</option>
              <option value="04">04</option>
              <option value="05">05</option>
              <option value="06">06</option>
              <option value="07">07</option>
              <option value="08">08</option>
              <option value="09">09</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>
              <option value="32">32</option>
              <option value="33">33</option>
              <option value="34">34</option>
              <option value="35">35</option>
              <option value="36">36</option>
              <option value="37">37</option>
              <option value="38">38</option>
              <option value="39">39</option>
              <option value="40">40</option>
              <option value="41">41</option>
              <option value="42">42</option>
              <option value="43">43</option>
              <option value="44">44</option>
              <option value="45">45</option>
              <option value="46">46</option>
              <option value="47">47</option>
              <option value="48">48</option>
              <option value="49">49</option>
              <option value="50">50</option>
              <option value="51">51</option>
              <option value="52">52</option>
              <option value="53">53</option>
              <option value="54">54</option>
              <option value="55">55</option>
              <option value="56">56</option>
              <option value="57">57</option>
              <option value="58">58</option>
              <option value="59">59</option>
            </select>
          </label>

          <span className="preposition">&nbsp;</span>

          <label className="select">
            <select
              ref={(input) => {this.ampm = input}}
              onChange={this.handleChange}
              defaultValue={defaultAmpm}
              disabled={this.props.disabled ? true : false}
            >
              <option value="am">AM</option>
              <option value="pm">PM</option>
            </select>
          </label>
        </div>
      )
    }
  }
}

export default TimeSelect;



// WEBPACK FOOTER //
// ./src/app/components/Modules/TimeSelect.js